(function () {
  var DEFAULT_PLACEHOLDER = 'Select';
  var EMPTY_STATE_DELAY = 220;
  var UPDATE_PULSE_MS = 180;
  var globalBound = false;

  function ensureMarkup(root) {
    if (root.classList.contains('km-select') && root.querySelector('.km-select__trigger')) {
      return;
    }
    root.classList.add('km-select');
    root.innerHTML =
      '<button type="button" class="km-select__trigger" aria-haspopup="listbox" aria-expanded="false">' +
      '<span class="km-select__label"></span>' +
      '<span class="km-select__chevron">\u25BE</span>' +
      '</button>' +
      '<div class="km-select__panel" role="listbox" tabindex="-1"></div>' +
      '<input type="hidden" class="km-select__value" />';
  }

  function getLabelEl(root) {
    return root.querySelector('.km-select__label');
  }

  function getPanel(root) {
    return root.querySelector('.km-select__panel');
  }

  function getHidden(root) {
    return root.querySelector('.km-select__value');
  }

  function getState(root) {
    root.__kmSelect = root.__kmSelect || { config: {} };
    root.__kmSelect.state = root.__kmSelect.state || {
      emptyTimer: null,
      pulseTimer: null
    };
    return root.__kmSelect.state;
  }

  function getPlaceholder(root, config) {
    return (config && config.placeholder) || root.getAttribute('data-placeholder') || DEFAULT_PLACEHOLDER;
  }

  function setExpanded(root, expanded) {
    var trigger = root.querySelector('.km-select__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function clearActive(panel) {
    if (!panel) return;
    Array.prototype.slice.call(panel.querySelectorAll('.km-select__option')).forEach(function (opt) {
      opt.classList.remove('is-active');
      opt.setAttribute('aria-selected', 'false');
    });
  }

  function emitChange(root, value, label) {
    root.dispatchEvent(
      new CustomEvent('kmselect:change', {
        detail: { value: value || '', label: label || '' }
      })
    );
  }

  function setLabel(root, text) {
    var el = getLabelEl(root);
    if (el) el.textContent = text || '';
  }

  function clearEmptyTimer(root) {
    var state = getState(root);
    if (!state.emptyTimer) return;
    clearTimeout(state.emptyTimer);
    state.emptyTimer = null;
  }

  function clearPulseTimer(root) {
    var state = getState(root);
    if (!state.pulseTimer) return;
    clearTimeout(state.pulseTimer);
    state.pulseTimer = null;
  }

  function showEmptyState(panel) {
    panel.innerHTML = '';
    var empty = document.createElement('div');
    empty.className = 'km-select__empty';
    empty.textContent = 'No options';
    panel.appendChild(empty);
  }

  function showLoadingState(panel) {
    panel.innerHTML = '';
    var loading = document.createElement('div');
    loading.className = 'km-select__loading';
    for (var i = 0; i < 3; i += 1) {
      var line = document.createElement('span');
      line.className = 'km-select__loading-line';
      loading.appendChild(line);
    }
    panel.appendChild(loading);
  }

  function pulseUpdating(root, panel) {
    var state = getState(root);
    clearPulseTimer(root);
    root.classList.add('is-buffering');
    if (panel) {
      panel.classList.remove('is-refresh');
      window.requestAnimationFrame(function () {
        panel.classList.add('is-refresh');
      });
    }
    state.pulseTimer = setTimeout(function () {
      root.classList.remove('is-buffering');
      if (panel) panel.classList.remove('is-refresh');
      state.pulseTimer = null;
    }, UPDATE_PULSE_MS);
  }

  function setValue(root, value, label, silent) {
    var hidden = getHidden(root);
    if (hidden) hidden.value = value || '';
    setLabel(root, label || getPlaceholder(root, root.__kmSelect && root.__kmSelect.config));

    var panel = getPanel(root);
    if (panel) {
      clearActive(panel);
      var match = panel.querySelector('[data-value="' + CSS.escape(value || '') + '"]');
      if (match) {
        match.classList.add('is-active');
        match.setAttribute('aria-selected', 'true');
      }
    }

    if (!silent) emitChange(root, value, label);
  }

  function renderOptions(root, options) {
    var panel = getPanel(root);
    if (!panel) return;
    clearEmptyTimer(root);
    pulseUpdating(root, panel);

    if (!options || !options.length) {
      showLoadingState(panel);
      var state = getState(root);
      state.emptyTimer = setTimeout(function () {
        state.emptyTimer = null;
        if (!getPanel(root)) return;
        showEmptyState(panel);
      }, EMPTY_STATE_DELAY);
      return;
    }

    panel.innerHTML = '';
    options.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'km-select__option';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-value', item.value);
      btn.textContent = item.label;
      btn.setAttribute('aria-selected', 'false');
      panel.appendChild(btn);
    });
  }

  function open(root) {
    if (root.classList.contains('is-disabled')) return;
    adjustPanelPlacement(root);
    root.classList.add('is-open');
    setExpanded(root, true);
  }

  function close(root) {
    root.classList.remove('is-open');
    setExpanded(root, false);
  }

  function toggle(root) {
    if (root.classList.contains('is-open')) close(root);
    else open(root);
  }

  function adjustPanelPlacement(root) {
    var panel = getPanel(root);
    if (!panel) return;

    panel.style.top = '';
    panel.style.bottom = '';
    panel.style.maxHeight = '';

    var rect = root.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var gap = 8;
    var spaceBelow = Math.max(0, viewportHeight - rect.bottom - gap);
    var spaceAbove = Math.max(0, rect.top - gap);
    var shouldOpenAbove = spaceBelow < 180 && spaceAbove > spaceBelow;
    var available = shouldOpenAbove ? spaceAbove : spaceBelow;

    panel.style.maxHeight = Math.max(1, Math.floor(available)) + 'px';
    if (shouldOpenAbove) {
      panel.style.top = 'auto';
      panel.style.bottom = 'calc(100% + 6px)';
    } else {
      panel.style.top = 'calc(100% + 6px)';
      panel.style.bottom = 'auto';
    }
  }

  function bindGlobal() {
    if (globalBound) return;
    globalBound = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      var select = target.closest ? target.closest('.km-select') : null;
      Array.prototype.slice
        .call(document.querySelectorAll('.km-select.is-open'))
        .forEach(function (openSelect) {
          if (select !== openSelect) close(openSelect);
        });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      Array.prototype.slice
        .call(document.querySelectorAll('.km-select.is-open'))
        .forEach(function (openSelect) {
          close(openSelect);
        });
    });
  }

  function bindInstance(root) {
    if (root.__kmSelect && root.__kmSelect.bound) return;
    root.__kmSelect = root.__kmSelect || { config: {} };
    root.__kmSelect.bound = true;

    var trigger = root.querySelector('.km-select__trigger');
    var panel = getPanel(root);

    if (trigger) {
      trigger.addEventListener('click', function () {
        toggle(root);
      });
    }

    if (panel) {
      panel.addEventListener('click', function (event) {
        var option = event.target.closest('.km-select__option');
        if (!option) return;
        var value = option.getAttribute('data-value') || '';
        var label = option.textContent || '';
        setValue(root, value, label);
        close(root);
        if (root.__kmSelect && typeof root.__kmSelect.config.onChange === 'function') {
          root.__kmSelect.config.onChange({ value: value, label: label, element: root });
        }
      });
    }

    bindGlobal();
  }

  function init(root, config) {
    if (!root) return;
    ensureMarkup(root);
    root.__kmSelect = root.__kmSelect || { config: {} };
    getState(root);
    root.__kmSelect.config = config || {};

    var placeholder = getPlaceholder(root, config);
    setLabel(root, placeholder);

    var options = (config && config.options) || [];
    renderOptions(root, options);

    if (config && config.value) {
      setValue(root, config.value, config.label || config.value, true);
    }

    bindInstance(root);
  }

  function initAll(scope) {
    var root = scope || document;
    Array.prototype.slice.call(root.querySelectorAll('[data-km-select]')).forEach(function (el) {
      init(el, { placeholder: el.getAttribute('data-placeholder') || DEFAULT_PLACEHOLDER });
    });
  }

  function setOptions(root, options) {
    if (!root) return;
    renderOptions(root, options || []);
  }

  function getValue(root) {
    var hidden = getHidden(root);
    return hidden ? hidden.value : '';
  }

  function enable(root) {
    if (!root) return;
    root.classList.remove('is-disabled');
  }

  function disable(root) {
    if (!root) return;
    clearEmptyTimer(root);
    clearPulseTimer(root);
    root.classList.remove('is-buffering');
    root.classList.add('is-disabled');
    close(root);
  }

  window.KMSelect = {
    init: init,
    initAll: initAll,
    setOptions: setOptions,
    setValue: setValue,
    getValue: getValue,
    enable: enable,
    disable: disable
  };
})();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.KMSelect.initAll(document);
    });
  } else {
    window.KMSelect.initAll(document);
  }
